module.exports = __webpack_public_path__ + "img/core-2.5eed3ac.svg";